import { Component, HostBinding, Input, OnChanges, OnInit } from '@angular/core';
import { ThemePalette } from '@angular/material';

@Component({
  selector: 'lib-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
})
export class ButtonComponent implements OnInit, OnChanges {
  @Input() color: ThemePalette;
  @Input() weight: 'primary' | 'secondary' | 'tertiary' = 'tertiary';
  @Input() danger = false;
  @Input() type = 'button';
  @Input() icon: string;
  @Input() onlyIcon: string;
  @Input() @HostBinding('class.app-button--disabled') disabled = false;
  @Input() slim = false;
  @Input() short = false;
  @Input() small = false;

  constructor() {}

  ngOnInit(): void {}

  ngOnChanges() {
    if (this.onlyIcon && this.icon) {
      console.warn(
        `The icon attribute's value (${this.icon}) is redundant when onlyIcon attribute is set.`
      );
    }
  }
}
